import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import storage from '../../services/stoage.service'
import logo_slim from '../../assets/images/logo/phoenix_logo_90x90.png'
import { AutoComplete } from 'primereact/autocomplete'
import utils from '../../utils/index'
import _ from 'lodash'

export class AppTopbar extends Component {
  static defaultProps = {
    activeTopbarItem: null,
    topbarMenuActive: null,
    onMenuButtonClick: null,
    onTopbarItemClick: null,
    onTopbarMobileMenuButtonClick: null,
    layoutMode: 'overlay',
  }

  static propTypes = {
    activeTopbarItem: PropTypes.string,
    topbarMenuActive: PropTypes.bool,
    onMenuButtonClick: PropTypes.func.isRequired,
    onTopbarItemClick: PropTypes.func.isRequired,
    onTopbarMobileMenuButtonClick: PropTypes.func.isRequired,
    layoutMode: PropTypes.string,
  }

  constructor() {
    super()
    this.state = {
      empresas: [],
      currentCompanyInput: '',
      unidades: [],
      currentUnitInput: '',
    }
  }

  componentDidMount() {
    const currentCompany = storage.getCompany()
    const optionsEmpresa = _.orderBy(this.props.companies, 'label').map((company) => ({
      id: company.value,
      value: `${company.label}`,
    }))
    this.setState({
      empresas: optionsEmpresa,
      currentCompanyInput: currentCompany
        ? `${_.get(currentCompany, 'nomeEmpresa', _.get(currentCompany, 'codigoEmpresa', null))} (${_.get(
            currentCompany,
            'oid',
            ''
          )})`
        : '',
    })

    const currentUnit = storage.getUnit()
    const optionsUnidade = _.orderBy(this.props.units, 'label').map((obj) => ({
      id: obj.value,
      value: `${obj.label}`,
    }))
    this.setState({
      unidades: optionsUnidade,
      currentUnitInput: currentUnit
        ? `${_.get(currentUnit, 'sigla', _.get(currentUnit, 'codigo', null))} (${_.get(currentUnit, 'oid', '')})`
        : '[Todas]',
    })
  }

  getBoasVindas() {
    if (this.props.portalCliente) {
      return (
        <li style={{ float: 'left' }}>
          <span>
            <h2 style={{ marginTop: '0px', color: '#FFFFFF' }}>Bem vindo(a) {storage.getNomeUsuario()}</h2>
          </span>
        </li>
      )
    }
    return null
  }

  getListItemForMenuSearch() {
    if (this.props.portalCliente) {
      return null
    }

    return (
      <li
        style={{ float: 'left' }}
        className={classNames('search-item', {
          'active-topmenuitem': this.props.activeTopbarItem === 'search',
        })}
        onClick={(e) => this.onTopbarItemClick(e, 'search')}
      >
        <span className="md-inputfield">
          <AutoComplete
            placeholder={'Pesquisar'}
            autoFocus={true}
            inputStyle={{ width: '25em' }}
            value={this.state.searchText}
            onChange={(e) => this.setState({ searchText: e.value })}
            completeMethod={this.props.onSearchMenu}
            suggestions={this.props.searchOptions}
            field="labelBuscaRapida"
            onSelect={(e) => this.onSelectBuscaRapida(e)}
            onKeyPress={(e) => this.onKeyPress(e)}
          />
        </span>
      </li>
    )
  }

  normalizeSearchText = (value) => {
    return _.toLower(_.trim(_.defaultTo(value, '')))
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  }

  searchEmpresa = (e) => {
    const companies = this.props.companies
    const query = this.normalizeSearchText(_.get(e, 'query', ''))
    const filteredCompanies =
      query.length === 0
        ? companies
        : companies.filter((company) => {
            const normalizedLabel = this.normalizeSearchText(_.get(company, 'label', ''))
            const normalizedId = this.normalizeSearchText(_.get(company, 'value', ''))
            return normalizedLabel.includes(query) || normalizedId.includes(query)
          })

    const empresas = _.orderBy(filteredCompanies, 'label').map((company) => ({
      id: company.value,
      value: `${company.label}`,
    }))

    this.setState({ empresas })
  }

  formatEmpresaOption = (empresa) => {
    if (!empresa) {
      return ''
    }
    return `${_.get(empresa, 'value', '')} (${_.get(empresa, 'id', '')})`
  }

  formatUnidadeOption = (unidade) => {
    if (!unidade) {
      return '[Todas]'
    }
    if (_.toNumber(_.get(unidade, 'id', 0)) < 1) {
      return '[Todas]'
    }
    return `${_.get(unidade, 'value', '')} (${_.get(unidade, 'id', '')})`
  }

  resolveAutoCompleteWidth = (value, minWidthCh = 24) => {
    const textLength = _.toString(_.defaultTo(value, '')).length
    return `${Math.max(minWidthCh, textLength + 8)}ch`
  }

  onChangeEmpresa = (e) => {
    this.setState({
      currentCompanyInput: _.isObject(e.value) ? this.formatEmpresaOption(e.value) : _.defaultTo(e.value, ''),
    })
  }

  onSelectEmpresa = (e) => {
    this.setState({ currentCompanyInput: this.formatEmpresaOption(_.get(e, 'value', null)) })
    this.props.onChangeCompany({ value: e.value })
  }

  searchUnidade = (e) => {
    const units = this.props.units
    const query = this.normalizeSearchText(_.get(e, 'query', ''))
    const filteredUnits =
      query.length === 0
        ? units
        : units.filter((unit) => {
            const normalizedLabel = this.normalizeSearchText(_.get(unit, 'label', ''))
            const normalizedId = this.normalizeSearchText(_.get(unit, 'value', ''))
            return normalizedLabel.includes(query) || normalizedId.includes(query)
          })

    const unidades = _.orderBy(filteredUnits, 'label').map((obj) => ({
      id: obj.value,
      value: `${obj.label}`,
    }))

    this.setState({ unidades })
  }

  onChangeUnidade = (e) => {
    this.setState({
      currentUnitInput: _.isObject(e.value) ? this.formatUnidadeOption(e.value) : _.defaultTo(e.value, '[Todas]'),
    })
  }

  onSelectUnidade = (e) => {
    this.setState({ currentUnitInput: this.formatUnidadeOption(_.get(e, 'value', null)) })
    this.props.onChangeUnit({ value: e.value })
  }

  getListItemForEmpresaUnidade(nameCurrentUnit, nameCurrentCompany, companies, alteraUnidade) {
    if (this.props.portalCliente) {
      return null
    }
    const usuarioComUnicaUnidade = storage.getUsuarioUnidadeUnica()
    return (
      <li
        style={{ display: 'flex', alignItems: 'center' }}
        className={classNames({
          'active-topmenuitem': this.props.activeTopbarItem === 'company_unit',
        })}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <AutoComplete
            className="topbar-company-unit-autocomplete topbar-company-autocomplete"
            placeholder={'Empresa'}
            scrollHeight="360px"
            style={{ width: this.resolveAutoCompleteWidth(this.state.currentCompanyInput, 28) }}
            inputStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              color: '#ffffff',
              borderColor: 'transparent',
              textOverflow: 'clip',
            }}
            itemTemplate={(e) => this.formatEmpresaOption(e)}
            field="value"
            onChange={this.onChangeEmpresa}
            onSelect={this.onSelectEmpresa}
            suggestions={this.state.empresas}
            value={this.state.currentCompanyInput}
            completeMethod={this.searchEmpresa}
            name={'currentCompany'}
            dropdown={true}
            multiple={false}
          />
          <AutoComplete
            className="topbar-company-unit-autocomplete topbar-unit-autocomplete"
            disabled={!this.props.units || this.props.units.length === 0 || usuarioComUnicaUnidade || !alteraUnidade}
            placeholder={'Unidade'}
            scrollHeight="360px"
            style={{ width: this.resolveAutoCompleteWidth(this.state.currentUnitInput, 28) }}
            inputStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              color: '#ffffff',
              borderColor: 'transparent',
              textOverflow: 'clip',
            }}
            itemTemplate={(e) => this.formatUnidadeOption(e)}
            field="value"
            onChange={this.onChangeUnidade}
            onSelect={this.onSelectUnidade}
            suggestions={this.state.unidades}
            value={this.state.currentUnitInput}
            completeMethod={this.searchUnidade}
            name={'currentUnit'}
            dropdown={true}
            multiple={false}
          />
        </div>
      </li>
    )
  }

  onTopbarItemClick(event, item) {
    if (this.props.onTopbarItemClick) {
      this.props.onTopbarItemClick({
        originalEvent: event,
        item: item,
      })
    }
  }

  onSelectBuscaRapida(e) {
    this.setState({ searchText: '' })
    this.props.onSelectBuscaRapida(e)
  }

  onKeyPress(e) {
    // if (e.key === "Enter") {
    //   const options = this.props.searchOptions;
    //   if (!utils.isArrayNullOrEmpty(options)) {
    //     const menu = options[0];
    //     e.value = menu;
    //     this.onSelectBuscaRapida(e);
    //   }
    // }
  }

  addTopBarContent() {
    if (this.props.isPublicRoute) {
      return null
    }

    function removeDuplicated(arr, key) {
      const map = new Map()
      arr.map((el) => {
        if (!map.has(el[key])) {
          map.set(el[key], el)
        }
      })
      return [...map.values()]
    }
    const companies = removeDuplicated(this.props.companies, 'value')
    const alteraUnidade = storage.getAlteraUnidade()
    const nameCurrentCompany = this.props.companies.find((company) => company.value === this.props.companyOid)
    let nameCurrentUnit
    if (this.props.units) {
      nameCurrentUnit = this.props.units.find((unit) => unit.value === this.props.unitOid)
    }

    let topbarClass = classNames('topbar-menu fadeInDown', {
      'topbar-menu-active': this.props.topbarMenuActive,
    })

    return (
      <React.Fragment>
        <button className="p-link menu-btn" onClick={this.props.onMenuButtonClick}>
          <i className="pi pi-bars" />
        </button>

        <button className="p-link topbar-menu-btn" onClick={this.props.onTopbarMobileMenuButtonClick}>
          <i className="pi pi-user" />
        </button>

        <div className="layout-topbar-menu-wrapper">
          <ul className={topbarClass}>
            <li
              className={classNames({
                'active-topmenuitem': this.props.activeTopbarItem === 'settings',
              })}
            >
              <button type={'button'} className="p-link" onClick={(e) => this.onTopbarItemClick(e, 'settings')}>
                <i className="pi pi-user" />
                <span className="topbar-item-name">Settings</span>
              </button>
              <ul className="fadeInDown" style={{ overflow: 'visible' }}>
                <li role="menuitem">
                  <div className="card">
                    <div>
                      <p>Login: {storage.getUser()}</p>
                    </div>
                    <div>
                      <p>Usuário: {storage.getNomeUsuario()}</p>
                    </div>
                    <div>
                      <p>Versão:{storage.getVersaoSistema()}</p>
                    </div>
                    <div>
                      <p>Data: {utils.formatarData(new Date())}</p>
                    </div>
                  </div>
                </li>
                <li role="menuitem">
                  <button className="p-link" onClick={(e) => this.onTopbarItemClick(e, 'logout')}>
                    <i className="pi pi-sign-out" />
                    <span>Logout</span>
                  </button>
                </li>
              </ul>
            </li>

            {this.getListItemForEmpresaUnidade(nameCurrentUnit, nameCurrentCompany, companies, alteraUnidade)}
            {this.getListItemForMenuSearch()}
            {this.getBoasVindas()}
          </ul>
        </div>
      </React.Fragment>
    )
  }

  render() {
    let horizontalIcon = this.props.layoutMode === 'horizontal' && (
      <button className="p-link topbar-logo">
        <img alt="logo" src={logo_slim} />
        <span className="app-name">PHOENIX</span>
      </button>
    )

    return (
      <div className="layout-topbar">
        {horizontalIcon}
        <img alt="logo" src={logo_slim} className="mobile-logo" />

        {this.addTopBarContent()}
      </div>
    )
  }
}
